import React, { createContext, useContext, useState } from 'react';

import Alerta, { Props as AlertaProps } from './Alerta';
import Confirmacao, { Props as ConfirmacaoProps } from './Confirmacao';
import Pergunta, { Props as PerguntaProps } from './Pergunta';
import Toast, { Props as ToastProps } from './Toast';

interface Props {
    children: React.ReactElement | React.ReactElement[];
}

interface ToastInterface extends Partial<ToastProps> {
    conteudo: string;
    aoFechar?: () => void;
}

interface Contexto {
    toasts: Array<ToastInterface>;
    setToasts: (toasts: Array<ToastInterface>) => void;
    setConfirmacao: (props: ConfirmacaoProps | null) => void;
    setAlerta: (props: AlertaProps | null) => void;
    setPergunta: (props: PerguntaProps | null) => void;
}

export const AlertaContexto = createContext<Contexto>({
    toasts: [],
    setToasts: (toasts) => ({ toasts }),
    setAlerta: (props) => ({ props }),
    setConfirmacao: (props) => ({ props }),
    setPergunta: (props) => ({ props }),
});

const AlertaProvider = ({ children }: Props): React.ReactElement =>
{
    const [ toasts, setToasts ] = useState<Array<ToastInterface>>([]);
    const [ alerta, setAlerta ] = useState<AlertaProps | null>();
    const [ confirmacao, setConfirmacao ] = useState<ConfirmacaoProps | null>();
    const [ pergunta, setPergunta ] = useState<PerguntaProps | null>();

    return (
        <AlertaContexto.Provider value={{ toasts, setToasts, setAlerta, setConfirmacao, setPergunta }}>
            { children }
            { alerta && (
                <Alerta {...alerta} />
            ) }
            { confirmacao && (
                <Confirmacao {...confirmacao} />
            ) }
            { pergunta && (
                <Pergunta {...pergunta} />
            ) }
            <div className="position-fixed bottom-0 end-0 toast-container p-3 z-index-5000">
                { toasts.map((toast, indice) => {
                    setTimeout(() => {
                        if (toasts[indice]) {
                            setToasts([ ...toasts.filter((t, i) => indice != i) ])
                        }
                    }, 2000);

                    return (
                        <Toast
                            key={ indice.toString() }
                            titulo={ toast.titulo }
                            conteudo={ toast.conteudo }
                            tema={ toast.tema }
                            botoes={ toast.botoes }
                            aoFechar={ () => setToasts([ ...toasts.filter((t, i) => indice != i) ]) }
                            criado={ toast.criado }
                        />
                    );
                }) }
            </div>
        </AlertaContexto.Provider>
    )
}

export function useAlerta()
{
    const { setAlerta } = useContext(AlertaContexto);

    return setAlerta;
}

export function useConfirmacao()
{
    const { setConfirmacao } = useContext(AlertaContexto);

    return setConfirmacao;
}

export function usePergunta()
{
    const { setPergunta } = useContext(AlertaContexto);

    return setPergunta;
}

export function useToast()
{
    const { toasts, setToasts } = useContext(AlertaContexto);

    return (toast: ToastInterface) => setToasts([
        ...toasts,
        { ...toast, criado: new Date() }
    ]);
}

export default AlertaProvider;
